import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";

function Breadcrumb({ items, children }) {
  return (
    <div className="d-none d-md-flex align-items-center mb-2">
      <div>
        <ol className="breadcrumb">
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            return (
              <li key={index} className={`breadcrumb-item${isLast ? " active" : ""}`}>
                {isLast || !item.to ? item.label : <Link to={item.to}>{item.label}</Link>}
              </li>
            );
          })}
        </ol>
      </div>
      {children && <div className="ms-auto">{children}</div>}
    </div>
  );
}

Breadcrumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      to: PropTypes.string,
    }),
  ).isRequired,
  children: PropTypes.node,
};

export default Breadcrumb;
